import React from "react"
import PropTypes from "prop-types"
import { enumValueSort, textGenericFilter } from "shared/search/containers/Filter/Filters"
import { enumGenericFilter, searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    AgencySearchifyFLV,
    RegulationFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import { AgencySelect, RegulationSelect } from "app/static/frontend/selects/containers/PieSelect"

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    helpText: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    placeholderText: PropTypes.string,
}

const defaultEnumPropTypes = {
    displayLabel: PropTypes.string,
    displayKey: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    enumItems: PropTypes.array,
    helpText: PropTypes.string,
    sortBy: PropTypes.func,
}

// enum
export const DocketDocketTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
DocketDocketTypeFilter.propTypes = defaultEnumPropTypes
DocketDocketTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "docketDocketTypeFilter",
    filterKey: "docket_type__in",
    enumItems: DjangIO.app.reg.types.DocketType.region_supported_items(),
    displayKey: "search_filter_label",
    sortBy: enumValueSort,
    displayLabel: "Docket Type",
}

// searchify
export const DocketAgencyFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={AgencySearchifyFLV} {...props} />
}
DocketAgencyFilter.propTypes = defaultPropTypes
DocketAgencyFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "docketAgencyFilter",
    filterKey: "associated_with_agencies_sharing_enhanced_agency_name_and_region",
    dataTypeLabel: "Agencies",
    displayLabel: "Agencies",
    selectComponent: AgencySelect,
}

export const DocketRegulationFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={RegulationFilterableListView} {...props} />
}
DocketRegulationFilter.propTypes = defaultPropTypes
DocketRegulationFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "docketRegulationFilter",
    filterKey: "contains_regulations",
    dataTypeLabel: "Regulations",
    displayLabel: "Regulations",
    selectComponent: RegulationSelect,
}

// text
export const DocketTitleFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
DocketTitleFilter.propTypes = defaultPropTypes
DocketTitleFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "docketTitleFilter",
    filterKey: "title_search",
    placeholderText: "Search text of Docket title...",
    displayLabel: "Search Titles",
}

export const DocketDescriptionFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
DocketDescriptionFilter.propTypes = defaultPropTypes
DocketDescriptionFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "docketDescriptionFilter",
    filterKey: "description_search",
    placeholderText: "Search text of Docket description...",
    displayLabel: "Search Descriptions",
}

export const DocketDocketIdFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
DocketDocketIdFilter.propTypes = defaultPropTypes
DocketDocketIdFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "docketDocketIdFilter",
    filterKey: "docket_id_search",
    placeholderText: "Search text of Docket ID...",
    displayLabel: "Search IDs",
}

// adders
